import { render, staticRenderFns } from "./Safari.vue?vue&type=template&id=d35d58dc&"
import script from "./Safari.vue?vue&type=script&lang=js&"
export * from "./Safari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports